"use client";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import {
  BriefcaseBusiness,
  ContactRound,
  FileClock,
  FileSignature,
  Home,
  Settings,
} from "lucide-react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Badge } from "../ui/badge";

export default function AppHeader({ isCollapsed }: { isCollapsed: boolean }) {
  const pathname = usePathname();

  const isActive = (page: string) => {
    return pathname === page;
  };

  return (
    <nav
      className={` ${isCollapsed ? `px-1` : `px-2 lg:px-4`}  grid items-start  text-sm font-medium  pt-2 transition-all`}
    >
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger>
            <Link
              href="/dashboard"
              className={`${isActive("/dashboard") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary`}
            >
              <Home className="h-4 w-4" />
              {!isCollapsed && `Dashboard`}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Dashboard</p>
            </TooltipContent>
          )}
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <Link
              href="/timesheets"
              className={`${isActive("/timesheets") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg px-3 py-2 text-muted-foreground transition-all hover:text-primary`}
            >
              <FileClock className="h-4 w-4" />
              {!isCollapsed && `Timesheets`}
              {!isCollapsed && (
                <Badge
                  className={`ml-auto flex h-5 w-5 shrink-0 items-center justify-center rounded-full`}
                >
                  6
                </Badge>
              )}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Timesheets</p>
            </TooltipContent>
          )}
        </Tooltip>
        <Tooltip>
          <TooltipTrigger>
            <Link
              href="/contracts"
              className={`${isActive("/contracts") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg  px-3 py-2  transition-all hover:text-primary`}
            >
              <FileSignature className="h-4 w-4" />
              {!isCollapsed && `Contracts`}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Contracts</p>
            </TooltipContent>
          )}
        </Tooltip>
        <Tooltip defaultOpen={false}>
          <TooltipTrigger>
            <Link
              href="/clients"
              className={`${isActive("/clients") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg px-3 py-2  transition-all hover:text-primary`}
            >
              <BriefcaseBusiness className="h-4 w-4" />
              {!isCollapsed && `Clients`}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Clients</p>
            </TooltipContent>
          )}
        </Tooltip>

        <Tooltip defaultOpen={false}>
          <TooltipTrigger>
            <Link
              href="/contacts"
              className={`${isActive("/contacts") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg px-3 py-2  transition-all hover:text-primary`}
            >
              <ContactRound className="h-4 w-4" />
              {!isCollapsed && `Contacts`}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Contacts</p>
            </TooltipContent>
          )}
        </Tooltip>

        <Tooltip defaultOpen={false}>
          <TooltipTrigger>
            <Link
              href="/settings"
              className={`${isActive("/settings") ? "bg-muted text-primary" : "text-muted-foreground"} min-h-[37px] flex items-center gap-3 rounded-lg px-3 py-2  transition-all hover:text-primary`}
            >
              <Settings className="h-4 w-4" />
              {!isCollapsed && `Settings`}
            </Link>
          </TooltipTrigger>
          {isCollapsed && (
            <TooltipContent side="right" sideOffset={10}>
              <p>Settings</p>
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </nav>
  );
}
